import React from 'react';
import { brandAssets } from '../../data/brandAssets';
type WordmarkProps = {
  kind?: 'wordmark' | 'compact';
  /**
   * When the surrounding surface is dark blue, the supplied black artwork is
   * placed on a light brand plate instead of being recolored.
   */
  onDark?: boolean;
  className?: string;
};

/**
 * Renders the official supplied BCM logo artwork. The SVG is never redrawn,
 * retyped, stretched, or recolored — width stays automatic so the aspect ratio
 * is always preserved.
 */
export function Wordmark({
  kind = 'wordmark',
  onDark = false,
  className = ''
}: WordmarkProps) {
  const src = kind === 'wordmark' ? brandAssets.wordmark : brandAssets.logoCompact;
  const image = <img src={src} alt="UCF BCM" className={`block w-auto shrink-0 ${className}`} draggable={false} data-id="element-49" data-mp="30lm9ft5roumg" />;
  if (!onDark) return image;
  return <span className="inline-flex items-center rounded-2xl bg-brand-tan px-4 py-3" data-id="element-50" data-mp="2moqq97vsxmso">{image}</span>;
}